<template>
  <div class="ni-app-login-wrapper is-desktop is-centered">
    <div class="ni-app-login-email-content columns">
      <b-field
        class="column is-half is-4-desktop is-offset-4-desktop"
        label="User name"
      >
        <b-input placeholder="User name" type="text" v-model="userName">
        </b-input>
      </b-field>
    </div>
    <div class="ni-app-login-password-content columns">
      <b-field
        class="column is-half is-4-desktop is-offset-4-desktop"
        label="Password"
      >
        <b-input
          type="password"
          placeholder="Password"
          v-model="password"
          @keyup.enter.native="authenticateUser"
        >
        </b-input>
      </b-field>
    </div>
    <b-button
      type="is-success"
      size="is-medium"
      class="column is-1-desktop is-offset-4-desktop ni-app-login-button"
      @click="authenticateUser"
      @keyup.enter.native="authenticateUser"
      >Login</b-button
    >
    <b-message
      class="column is-4-desktop is-offset-4-desktop ni-login-error"
      type="is-danger"
      v-show="showLoginError"
    >
      {{ loginErrorMessage }}
    </b-message>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      userName: "",
      password: "",
      showLoginError: false,
      loginErrorMessage: ""
    };
  },
  methods: {
    routeToSubmissionsView() {
      this.$routeTo.push({ path: "/homePage" });
    },
    authenticateUser() {
      if (this.password.trim() === "") {
        this.showLoginError = true;
        this.loginErrorMessage = "INVALID_CREDENTIALS";
      } else {
        var loginComponentScope = this;
        var args = {
          headers: {
            "content-type": "application/json"
          }
        };
        // loginComponentScope.isLoginInProgress = true;
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}authenticate`,
            {
              networkId: this.userName,
              password: this.password
            },
            args
          )
          .then(function(response) {
            loginComponentScope.showLoginError = false;
            // loginComponentScope.isLoginInProgress = false;
            if (sessionStorage.getItem("se_ni_user")) {
              sessionStorage.removeItem("se_ni_user");
            }
            window.$cookies.set("ni_key", response.data);
            loginComponentScope.routeToSubmissionsView();
          })
          .catch(function(error) {
            loginComponentScope.showLoginError = true;
            loginComponentScope.loginErrorMessage = error.response.data.message;
            console.log(error);
          });
      }
    }
  }
};
</script>
